import { useCallback, useRef, useState } from "react";

import { useGuestAuthMutation } from "../../entities/auth";
import { localStorageService, refreshSession } from "../../shared/api";

const useTokenManagement = () => {
  const [guestAuth] = useGuestAuthMutation();
  const [isTokenManagementLoaded, setIsTokenManagementLoaded] = useState(false);
  const [isTokenManagementSuccess, setIsTokenManagementSuccess] =
    useState(false);
  const hasCompletedInitialLoad = useRef(false);

  const performGuestAuth = useCallback(async () => {
    try {
      const result = await guestAuth().unwrap();
      if (result?.token) {
        setIsTokenManagementSuccess(true);
      }
    } catch (error) {
      console.error("Error during guest auth:", error);
      setIsTokenManagementSuccess(false);
    }
  }, [guestAuth]);

  const refreshStoredToken = useCallback(async () => {
    try {
      const token = await localStorageService.getRefreshToken();
      if (!token) {
        await performGuestAuth();
        return;
      }

      const result = await refreshSession();
      if (result === "ok") {
        setIsTokenManagementSuccess(true);
        return;
      }

      if (result === "unauthorized") {
        await performGuestAuth();
        if (hasCompletedInitialLoad.current) {
          window.location.reload();
        }
        return;
      }
    } catch (error) {
      console.error("Error in token management:", error);
    } finally {
      hasCompletedInitialLoad.current = true;
      setIsTokenManagementLoaded(true);
    }
  }, [performGuestAuth]);

  return {
    refreshStoredToken,
    isTokenManagementLoaded,
    isTokenManagementSuccess,
  };
};

export default useTokenManagement;
